import { useCallback, useMemo } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import {
  TopBannerCard,
  HorizontalCard,
  EventCard,
  VerticalCard,
  ChannelHorizontalCard,
  BannerCard,
  TeamCard,
  MatchPosterCard
} from './Playlists'
import { IPlaylistItem } from '@/types'
import { CARD_TYPE } from '@/constants'
import { resolveNavigation, applyNavigation } from './navigation'
import { useHasSceneRoute } from '@/hooks/cinematics/useHasSceneRoute'
import { TEAM_ROUTES } from '@/utils/routes'

export { PLAYLIST_TRIGGER } from './navigation'

interface CardProps {
  isPlaceholder?: boolean
  item: IPlaylistItem | any
  itemIndex?: number
  options?: { cardType?: string, imageCut?: string }
  shouldLoadImage?: boolean
}

export const Card = (props: CardProps) => {
  const { item, itemIndex = 0, options, isPlaceholder = false, shouldLoadImage = true } = props
  const router = useRouter()
  const cardType = options?.cardType || CARD_TYPE.HORIZONTAL
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const referrer = useMemo(() => {
    const params = searchParams.toString()
    return params ? `${pathname}?${params}` : pathname
  }, [pathname, searchParams])
  const itemVideos = useMemo(() => item?.videos || [], [item])
  const isLocked = itemVideos.length > 0 && itemVideos.every((video: any) => video.isAuthorized === false)
  const hasMyTeamScene = useHasSceneRoute(TEAM_ROUTES.myTeam)

  const handleCardClick = useCallback((item: any, action?: { type?: string; trigger?: string }) => {
    const result = resolveNavigation({ item, action, videos: itemVideos, referrer, hasMyTeamScene })
    applyNavigation(router, result)
  }, [itemVideos, router, referrer, hasMyTeamScene])

  return (
    <>
      {cardType === CARD_TYPE.TOP_BANNER &&
        <TopBannerCard
          handleCardClick={handleCardClick}
          item={item}
          itemIndex={itemIndex}
          isPlaceholder={isPlaceholder}
          shouldLoadImage={shouldLoadImage}
        />
      }
      {cardType === CARD_TYPE.BANNER &&
        <BannerCard
          handleCardClick={handleCardClick}
          item={item}
          itemIndex={itemIndex}
          isPlaceholder={isPlaceholder}
        />
      }
      {cardType === CARD_TYPE.EVENT &&
        <EventCard
          handleCardClick={handleCardClick}
          isPlaceholder={isPlaceholder}
          item={item}
        />
      }
      {cardType === CARD_TYPE.HORIZONTAL &&
        <HorizontalCard
          handleCardClick={handleCardClick}
          imageCut={options?.imageCut}
          isPlaceholder={isPlaceholder}
          isLocked={isLocked}
          item={item}
        />
      }
      {cardType === CARD_TYPE.VERTICAL &&
        <VerticalCard
          handleCardClick={handleCardClick}
          imageCut={options?.imageCut}
          isPlaceholder={isPlaceholder}
          isLocked={isLocked}
          item={item}
        />
      }
      {cardType === CARD_TYPE.CHANNEL_HORIZONTAL &&
        <ChannelHorizontalCard
          handleCardClick={handleCardClick}
          imageCut={options?.imageCut}
          isPlaceholder={isPlaceholder}
          item={item}
        />
      }
      {cardType === CARD_TYPE.TEAM &&
        <TeamCard
          handleCardClick={handleCardClick}
          isPlaceholder={isPlaceholder}
          item={item}
        />
      }
      {cardType === CARD_TYPE.MATCH_POSTER &&
        <MatchPosterCard
          handleCardClick={handleCardClick}
          isPlaceholder={isPlaceholder}
          item={item}
        />
      }
    </>
  )
}